/**
 * Defaults for Operations variables. The base Operation controller {@link tmrOperationController}
 * uses manages options through the {@link TmrOperationHelper} service.
 *
 * @namespace tmrDefaultOperationsConfig
 * @type {ngConstant}
 * @prop {string} encodingDefaultZone Encoding: the id of the selected encoding zone
 * @prop {string} encodingEpcReadMode Encoding: the default epc read mode. Must be one of {@link tmrEncodingEpcReadModes}
 * @prop {boolean} outboundCustomAsnCode Outbound: the default state of the Custom Asn code switch
 * @prop {boolean} outboundCustomParcelCode Outbound: the default state of the Custom Parcel code switch
 * @prop {boolean} [printCart=false] Print: if true, the button remembers selected elements after page change
 */
export const constant = [
  'tmrDefaultOperationsConfig',
  {
    encodingDefaultZone: null,
    encodingEpcReadMode: 'reader',
    outboundCustomAsnCode: true,
    outboundCustomParcelCode: true,
    ttzChecklistEnable: false,
    outboundChecklistEnable: false,
    checklistValidationEnable: true,
    checklistValidationCheckUnexpected: true,
    checklistValidationCheckExpectedUnexpected: true,
    printCart: false,
  },
]
